module.exports = __webpack_public_path__ + "img/en-1-t.84401164.png";